module.exports = __webpack_public_path__ + "img/Emilee-Bell.4fa15522.png";